import { useTranslation } from 'react-i18next';
import { array, mixed } from 'yup';
import { BiogenFunction, CepStatus } from 'basics/enums/maya.enums';
import { testEndDayAfterStartDay } from 'basics/utils/dates/dates.utils';
import { InitiativeCountry } from 'generated/maya.types';

const useAdminDashboardFiltersSchema = () => {
  const { t } = useTranslation();

  return {
    countries: array().of(mixed<InitiativeCountry>().oneOf(Object.values(InitiativeCountry))).nullable(),
    therapeuticArea: mixed().nullable(),
    product: mixed().nullable(),
    cepFunction: array().of(mixed<BiogenFunction>().oneOf(Object.values(BiogenFunction))).nullable(),
    cepStatus: array().of(mixed<CepStatus>().oneOf(Object.values(CepStatus))).nullable(),
    date: mixed()
      .test({
        name: 'endDate must be after startDate',
        message: t('timeSlotBooking_endDate_errorMessage_earlierThanStart'),
        test: testEndDayAfterStartDay,
      }),
  };
};

export default useAdminDashboardFiltersSchema;
